(function(){
     'use strict';

     angular
        .module('app')
        .factory('GeneralService', GeneralService);

    GeneralService.$inject = ['$http'];

    function GeneralService($http){

        var service = {
        	format : function(icon){
        		  var originalOption = icon.element;
	              var str = "";
	              if(typeof $(originalOption).data('icon') != 'undefined'){
	                str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                return $(str+" ");
	              }else{
	                return icon.text || icon.value;
	              }
        	},
        	optionsSelect2 : { 
        		ajax: {
                    url: "/ajax/select2",
                    dataType: 'json',
                    //delay: 0,
                    data: function (params) {
                      return {
                        q: params.term, // search term
                        page: params.page,
                        field: 'nombre',
                        per_page: 20,
                      };
                    },
                    processResults: function (data, params) {
                      params.page = params.page || 1;
                      return {
                        results: data.items,
                        pagination: {
                          more: (params.page * 1) < data.total_count
                        }
                      };
                    },
                    //cache: true
                },
                templateSelection: function(icon){
              var originalOption = icon.element;
                var str = "";
                if(typeof $(originalOption).data('icon') != 'undefined'){
                  str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
                  return $(str+" ");
                }else{
                  return icon.text || icon.value;
                }
          },
                templateResult: function(icon){
              var originalOption = icon.element;
                var str = "";
                if(typeof $(originalOption).data('icon') != 'undefined'){
                  str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
                  return $(str+" ");
                }else{
                  return icon.text || icon.value;
                }
          }
        	}
        };

         

        return service;
 		

    }
})();